import { SET_AL_WARN_MSG } from "../../actions/action.types";

const ALWarnMsg = (state = "", action: any) => {
  if (action.type === SET_AL_WARN_MSG) return action.payload;
  else return state;
};

export default ALWarnMsg;
